export default __webpack_public_path__ + "static/media/help.c38e301d.png";